export default __webpack_public_path__ + "df01cbda7d89c2d79c9bc9a20f7ab68a.png";